module.exports = __webpack_public_path__ + "static/media/mailBanner.57f8e083.png";